import './mockEnv';

import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { Root } from '@/components/Root';
import { Unsupported } from '@/components/Unsupported';
import { preloadStrings } from '@/lang';
import { launch } from '@/platform';
import { initSentry, reportError } from '@/sentry';
import { CENTER } from '@/components/center';
import { installStaleChunkReload } from '@/staleChunk';
import { unsupportedFeatures } from '@/support';
import { STR } from '@/str';
import { startVitals } from '@/vitals';
import '@fontsource-variable/golos-text/wght.css';
import '@fontsource-variable/nunito/wght.css';
import './index.css';

installStaleChunkReload();
setTimeout(preloadStrings, 0);

const root = ReactDOM.createRoot(document.getElementById('root')!);

const missing = unsupportedFeatures();

if (missing.length > 0) {
  root.render(<Unsupported />);
  reportError(new Error(`unsupported webview: ${missing.join(' ')}`), {
    missing,
    userAgent: navigator.userAgent,
  });
  initSentry();
} else {
  if (!launch()) {
    root.render(
      <div className={CENTER}>
        <p>{STR.uzl.openInTelegram}</p>
      </div>,
    );
  } else {
    root.render(
      <StrictMode>
        <ErrorBoundary>
          <Root />
        </ErrorBoundary>
      </StrictMode>,
    );
    initSentry();
    startVitals();
  }
}
